/* "Added to basket" modal — called by main.js ProductForm after a successful
   cart add (afterAddToCart === 'notification'). Template: #DfAddedModal. */
(function () {
  window.dfShowAddedModal = function (data) {
    var tpl = document.getElementById('DfAddedModal');
    if (!tpl) return;

    document.querySelectorAll('.df-added-modal-wrap').forEach(function (el) { el.remove(); });
    var node = tpl.content.firstElementChild.cloneNode(true);

    var imgUrl = data.image || (data.featured_image && data.featured_image.url) || '';
    var img = node.querySelector('[data-df-am-image]');
    if (imgUrl) {
      img.src = imgUrl;
      img.alt = data.product_title || '';
    } else {
      node.querySelector('.df-added-modal__media').style.display = 'none';
    }

    node.querySelector('[data-df-am-title]').textContent = data.product_title || '';

    var vEl = node.querySelector('[data-df-am-variant]');
    var vText = '';
    if (data.variant_title && data.variant_title !== 'Default Title' && data.options_with_values) {
      vText = data.options_with_values.map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
    }
    if (vText) { vEl.textContent = vText; } else { vEl.remove(); }

    var pEl = node.querySelector('[data-df-am-price]');
    try {
      var fmt = tpl.dataset.moneyFormat || '£{{amount}}';
      var cents = data.final_price != null ? data.final_price : data.price;
      var formatted = '';
      if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
        formatted = theme.Shopify.formatMoney(cents, fmt);
      } else {
        formatted = '£' + (cents / 100).toFixed(2);
      }
      pEl.textContent = formatted.replace(/\.00(?=\D|$)/, '');
    } catch (e) { pEl.textContent = ''; }

    var close = function () {
      node.classList.add('df-added-modal-wrap--hidden');
      setTimeout(function () { node.remove(); }, 250);
    };
    node.addEventListener('click', function (e) { if (e.target === node) close(); });
    node.querySelectorAll('[data-df-am-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });

    document.body.appendChild(node);
    requestAnimationFrame(function () { node.classList.remove('df-added-modal-wrap--hidden'); });
    var focusBtn = node.querySelector('.df-added-modal__checkout');
    if (focusBtn) focusBtn.focus();
  };
})();
